document.addEventListener("DOMContentLoaded", function () {
  let ticking = false;

  function disableZoom() {
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    const contentStr = "width=device-width, initial-scale=1.0, maximum-scale=1.0";

    if (viewportMeta) {
      viewportMeta.setAttribute("content", contentStr);
    } else {
      viewportMeta = document.createElement("meta");
      viewportMeta.name = "viewport";
      viewportMeta.content = contentStr;
      document.head.appendChild(viewportMeta);
    }
  }

  disableZoom();

  function getKeyboardHeight() {
    const vv = window.visualViewport;
    if (!vv) return 0;
    return window.innerHeight - vv.height - Math.max(0, vv.offsetTop);
  }

  function updatePosition() {
    const el = document.querySelector(".cart-summary-container");
    if (!el) return;
    const keyboardHeight = getKeyboardHeight();

    if (keyboardHeight > 0) {
      el.style.transform = `translate3d(0, -${keyboardHeight}px, 0)`;
    } else {
      el.style.transform = `translate3d(0, 0, 0)`;
    }
    ticking = false;
  }

  function handleViewport() {
    if (!ticking) {
      window.requestAnimationFrame(updatePosition);
      ticking = true;
    }
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", handleViewport);
    window.visualViewport.addEventListener("scroll", handleViewport);
  }

  document.addEventListener("focusin", (e) => {
    const target = e.target;
    if (!["INPUT", "TEXTAREA"].includes(target.tagName)) return;

    setTimeout(() => {
      const rect = target.getBoundingClientRect();
      const keyboardHeight = getKeyboardHeight();
      const visibleBottom = window.innerHeight - keyboardHeight;

      if (rect.bottom > visibleBottom) {
        const offset = rect.bottom - visibleBottom + 20;
        window.scrollBy({
          top: offset,
          behavior: "smooth",
        });
      }
    }, 300);
  });
});
